/**
 * API по базовым справочникам АМЛ.
 * API по базовым справочникам АМЛ.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные записи общероссийского классификатора видов экономической деятельности (Ред. 2).
 */
export interface QrefOkwed2 { 
    /**
     * Код. Ключевое поле таблицы.
     */
    code?: string;
    /**
     * Описание.
     */
    name?: string;
}

